export const mediaSize = {
  large: '1200px',
  desktop: '992px',
  tablet: '768px',
  phone: '576px',
};
